module.exports = __webpack_public_path__ + "static/media/D1-Abzeichen.68587e7d.jpg";